import React from 'react';
import _ from 'lodash';
import { MobileMenu, MenuTypefaces, Menu, MenuScripts, Footer, BackgroundColorChanger, DeviseError, RecaptchaWidget } from '../components';
import { changeLoginInfo } from '../actions';
import { connect } from 'react-redux';
import { Container, Gutter, LeftColumn, Title, FormField, FormBorderWrapper, PrimaryButton, PaddingDiv, ButtonArea, BorderArea, MenuGutter, DesktopHr } from '../stylesheets/components';
import styled from 'styled-components';
import { Form, Field } from 'react-final-form';

const Fragment = React.Fragment;

const PasswordInfoText = styled.div`
margin-bottom: 15px;
font-size: 18px;
`

const FormErrorBox = styled.div`
  color: #c62828;
  font-size: 14px;
  margin-bottom: 15px;
  padding: 10px;
  background-color: #ffebee;
  border-radius: 4px;
`;

class SignUp extends React.Component {
  constructor(props) {
    super(props);
    this.props.dispatch(changeLoginInfo(
      this.props.new_user_session_path,
      this.props.current_user,
      this.props.user_signed_in,
      this.props.destroy_user_session_path
    ));

    this.state = {
      recaptchaToken: '',
      formErrors: {},
      isSubmitting: false
    };

    this.handleRecaptchaTokenChange = this.handleRecaptchaTokenChange.bind(this);
    this.onFormSubmit = this.onFormSubmit.bind(this);
  }

  handleRecaptchaTokenChange(token) {
    this.setState(prevState => ({
      recaptchaToken: token,
      formErrors: {
        ...prevState.formErrors,
        recaptcha: null
      }
    }));
  }

  validateFormValues(values) {
    const errors = {};

    const email = (values.email || '').trim();
    const fullname = (values.fullname || '').trim();
    const password = values.password || '';
    const passwordConfirmation = values.passwordConfirmation || '';
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (_.isEmpty(email)) {
      errors.email = "Email can't be blank";
    } else if (!emailRegex.test(email)) {
      errors.email = 'Please enter a valid email address';
    }

    if (_.isEmpty(fullname)) {
      errors.fullname = "Fullname can't be blank";
    }

    if (_.isEmpty(password)) {
      errors.password = "Password can't be blank";
    } else {
      // Password must be at least 8 characters and contain uppercase, lowercase, numbers and symbols
      const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z\d])[A-Za-z\d\W]{8,}$/;
      if (!passwordRegex.test(password)) {
        errors.password = 'Password should be at least 8 characters long and must contain each of the following: uppercase, lowercase, numbers and symbols';
      }
    }

    if (_.isEmpty(passwordConfirmation)) {
      errors.passwordConfirmation = "Password confirmation can't be blank";
    } else if (!_.isEmpty(password) && password !== passwordConfirmation) {
      errors.passwordConfirmation = 'Passwords do not match';
    }

    return errors;
  }

  onFormSubmit(e) {
    const isRecaptchaEnabled = !_.isEmpty(this.props.recaptcha_site_key);
    const form = e.currentTarget;
    const values = {
      email: form.elements['user[email]'] ? form.elements['user[email]'].value : '',
      fullname: form.elements['user[fullname]'] ? form.elements['user[fullname]'].value : '',
      password: form.elements['user[password]'] ? form.elements['user[password]'].value : '',
      passwordConfirmation: form.elements['user[password_confirmation]'] ? form.elements['user[password_confirmation]'].value : ''
    };
    const formErrors = this.validateFormValues(values);

    if (isRecaptchaEnabled && _.isEmpty(this.state.recaptchaToken)) {
      formErrors.recaptcha = 'Please complete the reCAPTCHA challenge';
    }

    if (!_.isEmpty(formErrors)) {
      e.preventDefault();
      this.setState({ formErrors, isSubmitting: false });
      return;
    }

    // Validation passed - show loading state and allow form to submit
    this.setState({ formErrors: {}, isSubmitting: true });
    // Form will submit naturally to Rails backend
  }

  render() {
    let { products, languages, typefacesPopup, errors, bwMode } = this.props;
    const isRecaptchaEnabled = !_.isEmpty(this.props.recaptcha_site_key);
    const formErrorMessages = _.compact([
      this.state.formErrors.email,
      this.state.formErrors.fullname,
      this.state.formErrors.password,
      this.state.formErrors.passwordConfirmation,
      this.state.formErrors.recaptcha
    ]);

    const tokenDom = document.querySelector("meta[name=csrf-token]");
    const csrfToken = tokenDom.content;

    return (
      <Fragment>
        <Menu isLogoutEnabled={true} />
        <MenuTypefaces foregroundColor="black" backgroundColor="white" products={products} />
        <MenuScripts languages={languages} />

        {
          typefacesPopup ?
            null :
            <Fragment>
              <BackgroundColorChanger color="#E0E0E0" bwMode="white" />

              <Container bwMode={bwMode} className="no-webfont">
                <BorderArea foregroundColor="black">
                  <MenuGutter />
                  <PaddingDiv>
                    <Title bwMode={bwMode}>
                      Create Account
                    </Title>
                  </PaddingDiv>
                </BorderArea>
                <BorderArea foregroundColor="black">
                  <DesktopHr foregroundColor="black" />
                  <LeftColumn bwMode={bwMode}>


                    <PaddingDiv>

                      {
                        _.isUndefined(errors) ?
                          null :
                          <DeviseError {...errors} />
                      }
                      <PasswordInfoText>Password should be at least 8 characters long and must contain each of the following: uppercase, lowercase, numbers and symbols.</PasswordInfoText>
                      {
                        _.isEmpty(formErrorMessages) ? null :
                          <FormErrorBox>
                            {formErrorMessages.map((error, index) => (
                              <div key={index}>{error}</div>
                            ))}
                          </FormErrorBox>
                      }

                      <Form
                        onSubmit={() => {}}
                        render={({ submitting }) => (
                          <form method="post" action={this.props.registration_path} onSubmit={this.onFormSubmit}>
                            <input type="hidden" name="authenticity_token" value={csrfToken} />
                            <input type="hidden" name="recaptcha_token" value={this.state.recaptchaToken} />
                            <input type="hidden" name="g-recaptcha-response" value={this.state.recaptchaToken} />
                            <FormBorderWrapper bwMode={bwMode}>
                              <FormField bwMode={bwMode}>
                                <label>Email</label>
                                <Field
                                  name="user[email]"
                                  component="input"
                                  type="email"
                                  autoFocus={true}
                                  autoComplete="email"
                                  placeholder="abc@universalthirst.com"
                                />
                              </FormField>
                              <FormField bwMode={bwMode}>
                                <label>Fullname</label>
                                <Field
                                  name="user[fullname]"
                                  component="input"
                                  type="text"
                                  autoFocus={false}
                                  autoComplete="fullname"
                                  placeholder="John Doe"
                                />
                              </FormField>
                              <FormField bwMode={bwMode}>
                                <label>Password</label>
                                <Field
                                  name="user[password]"
                                  component="input"
                                  type="password"
                                  autoComplete="current-password"
                                  placeholder="******"
                                />
                              </FormField>
                              <FormField bwMode={bwMode}>
                                <label>Password Confirmation</label>
                                <Field
                                  name="user[password_confirmation]"
                                  component="input"
                                  type="password"
                                  autoComplete="current-password"
                                  placeholder="******"
                                />
                              </FormField>
                            </FormBorderWrapper>
                            <RecaptchaWidget
                              siteKey={this.props.recaptcha_site_key}
                              onTokenChange={this.handleRecaptchaTokenChange}
                            />
                            <Gutter h={20} />

                            <ButtonArea>
                              <div>
                                <PrimaryButton bwMode={bwMode} type="submit" disabled={this.state.isSubmitting || (isRecaptchaEnabled && _.isEmpty(this.state.recaptchaToken))}>
                                  {this.state.isSubmitting ? 'Processing...' : 'Submit'}
                                </PrimaryButton>
                                {/* <ButtonA bwMode={bwMode} href={this.props.new_session_path}>
                                  Login
                                </ButtonA> */}
                              </div>
                              <div>
                                <a href={this.props.new_password_path}>Forgot password?</a>
                              </div>
                            </ButtonArea>
                          </form>
                        )}
                      />
                    </PaddingDiv>
                  </LeftColumn>
                </BorderArea>


              </Container>
              <Footer foregroundColor="black" />
            </Fragment>
        }

        <MobileMenu isLogoutEnabled={true} backgroundColor="#E0E0E0" foregroundColor="black" highlightColor="#000000" />
      </Fragment>
    );
  }
}

let mapStateToProps = state => {
  return {
    typefacesPopup: state.typefacesPopup,
    bwMode: state.bwMode
  }
}

export default connect(mapStateToProps)(SignUp);
